/* assets/js/pixelart.js
   Pixel-art bin-packing with strict 2× sizing + responsive clamp.
   Requires: imagesLoaded, Packery. Load after built/source.js
*/
(function () {
  'use strict';

  var grid = document.querySelector('.post-feed');
  if (!grid) return;

  // Only run on pages that actually have pixel previews
  if (!document.querySelector('.is-pixel-preview .pixel-preview-image')) return;

  // If Masonry is bound to this grid (other pages), disable it here
  if (window.Masonry) {
    var m = Masonry.data(grid);
    if (m) m.destroy();
  }

  if (!window.imagesLoaded || !window.Packery) return;

  var pckry = null;

  // ---------- helpers ----------

  function stripGhostSizing(url) {
    if (!url) return url;
    var out = url.replace(/\/size\/[^/]+/i, '');
    out = out.replace(/([?&])w=\d+(&|$)/i, '$1').replace(/[?&]$/, '');
    return out;
  }

  function largestFromSrcset(srcset) {
    if (!srcset) return '';
    var best = { w: 0, url: '' };
    srcset.split(',').forEach(function (part) {
      var m = part.trim().match(/(\S+)\s+(\d+)w/);
      if (m) {
        var w = parseInt(m[2], 10);
        if (w > best.w) best = { w: w, url: m[1] };
      }
    });
    return best.url || '';
  }

  function ensureOriginal(img, done) {
    var dataOrig = img.getAttribute('data-src-original');
    var desired =
      dataOrig ||
      stripGhostSizing(img.getAttribute('src') || img.currentSrc || '') ||
      largestFromSrcset(img.getAttribute('srcset'));

    if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
    if (img.hasAttribute('sizes'))  img.removeAttribute('sizes');

    if (desired && img.src !== desired) {
      img.addEventListener('load', function onLoad() {
        img.removeEventListener('load', onLoad);
        done();
      });
      img.src = desired;
      return;
    }

    if (img.complete && img.naturalWidth > 0) {
      done();
    } else {
      img.addEventListener('load', function once() {
        img.removeEventListener('load', once);
        done();
      });
    }
  }

  function getGutter() {
    var item = grid.querySelector('.grid-item');
    if (!item) return 0;
    var cs = getComputedStyle(item);
    var ml = parseFloat(cs.marginLeft)  || 0;
    var mr = parseFloat(cs.marginRight) || 0;
    return ml + mr;
  }

  // Use 1× when viewport is narrow (x1 scale tier), 2× otherwise.
  function getPixelScale() {
    return window.innerWidth < 500 ? 1 : 2;
  }

  function sizeTo2x(img) {
    if (!img || !img.naturalWidth) return;

    var scale   = getPixelScale();
    var targetW = img.naturalWidth  * scale;
    var targetH = img.naturalHeight * scale;

    img.style.maxWidth = 'none';
    img.style.width    = targetW + 'px';
    img.style.height   = targetH + 'px';

    // clamp if the feed is narrower than target size
    var feedW = grid.clientWidth;
    var needsClamp = (targetW + getGutter()) > feedW;
    if (needsClamp) {
      img.style.maxWidth = '100%';
      img.style.height   = 'auto';
    }
  }

  function processImage(img) {
    ensureOriginal(img, function () {
      // next paint: naturalWidth is reliable
      requestAnimationFrame(function () { sizeTo2x(img); });
    });
  }

  function scan(root) {
    var imgs = root.querySelectorAll('.is-pixel-preview .pixel-preview-image');
    imgs.forEach(processImage);
  }

  function reflowAll() {
    var imgs = grid.querySelectorAll('.is-pixel-preview .pixel-preview-image');
    imgs.forEach(sizeTo2x);
    if (pckry) {
      pckry.reloadItems();
      pckry.layout();
    }
  }

  // ---------- init ----------

  imagesLoaded(grid, function () {
    scan(grid);

    pckry = new Packery(grid, {
      itemSelector: '.grid-item',
      percentPosition: false,
      initLayout: false
    });

    pckry.layout();
    reflowAll();                     // measure at final 2×/clamped sizes
    grid.classList.add('initialized');

    // hook infinite scroll: size -> append -> reflow
    function callback(items, loadNextPage) {
      imagesLoaded(items, function (loaded) {
        loaded.elements.forEach(function (el) { scan(el); });
        pckry.appended(items);
        reflowAll();
        loadNextPage();
      });
    }
    if (typeof pagination === 'function') {
      pagination(true, callback, true);
    }

    // bind lightbox for these posts
    if (typeof pswp === 'function') {
      pswp('.post-feed', '.post', '.post-link', '.post-caption', false);
    }
  });

  // reflow on resize / orientation changes
  var raf = null;
  window.addEventListener('resize', function () {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(reflowAll);
  });
  window.addEventListener('orientationchange', function () {
    setTimeout(reflowAll, 50);
  });

  // pick up any injected nodes
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function (muts) {
      var changed = false;
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) { scan(n); changed = true; }
        });
      });
      if (changed) reflowAll();
    });
    mo.observe(grid, { childList: true, subtree: true });
  }
})();
